export default {
  inter: 'Inter',
  montserrat: 'Montserrat'
}
